<mat-expansion-panel  #expansionPanel class="tablink" [expanded]="false"
  [ngClass]="{'first-panel': filterLabel === FilterLabel.FILE, 'last-panel': filterLabel === FilterLabel.NOTE}"
  [disabled]="!filterEnabled" [hideToggle]="true"
  [matTooltip]="filterLabel + ' filtering is disabled'"
  [matTooltipPosition]="'above'"
  [matTooltipDisabled]="filterEnabled">
  <mat-expansion-panel-header class="tabs custom-header">
    <mat-panel-title>
      <mat-slide-toggle [id]="'include-' + filterLabel?.toLowerCase() + 's'"
        [(ngModel)]="filterEnabled"
        [matTooltip]="'Include ' + filterLabel + 's in the prompt'"
        [matTooltipPosition]="'above'"
        [matTooltipShowDelay]="500"
        (click)="$event.stopPropagation()">
        <mat-icon fontIcon="{{ filterLabel === FilterLabel.FILE ? 'attach_file' : 'description' }}" class="material-icons-outlined"></mat-icon> {{ filterLabel }} filter
      </mat-slide-toggle>
      <mat-panel-description>
        <span>Include {{ filterLabel }}s in the prompt</span>
      </mat-panel-description>
    </mat-panel-title>
    <span class="mat-expansion-indicator" [class.disabled]="!filterEnabled"></span>
  </mat-expansion-panel-header>
  <table id="file-filter-table"
    class="full-width table-striped table-no-border-bottom table-td-border-right">
    <tr>
      <td colspan="2">
        <div class="basic-flex-container filter-types">
          <mat-label>{{ filterLabel }} {{ filterLabel === FilterLabel.FILE ? 'types' : 'actions' }}</mat-label>
          <div class="row chips-container"
            #chipsContainer>
            <app-document-type-picker #documentTypePicker
              [placeholderText]="placeHolderText"
              [filterLabel]="filterLabel"
              [namespace]="'bullhorn'"
              [entityType]="entityType ? [entityType.toString()] : []"
              [autoSelectOnExactMatch]="false"
              [position]="'initial'"
              [clearOnSelection]="true"
              [valid]="true"
              (selected)="onSelected($event)">
              <!--                                                [matTooltip]="!valid ? 'At least one ' + outputFileType + ' type must be selected.' : ''"-->
              <!--                                                [matTooltipPosition]="'right'"-->
              <!--                                                [matTooltipShowDelay]="500">-->
            </app-document-type-picker>
            @for (chip of documentTypes; track chip) {
              <button class="chip">
                {{ chip.label }}
                <mat-icon fontIcon="close"
                  class="remove-chip"
                  matTooltip="Remove {{ chip.label }}"
                  matTooltipShowDelay="500"
                (click)="onRemove(chip)"></mat-icon>
              </button>
            }
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="basic-flex-container">
          <mat-label>Date range of {{ filterLabel }}s to include</mat-label>
          <mat-select [(ngModel)]="filterDateTimeAmount" class="fit-content"
            [matTooltip]="getLabelByValue(filterDateTimeAmount)"
            [matTooltipShowDelay]="500">
            @for (option of predefinedDates; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </div>
      </td>
      <td>
        <div class="basic-flex-container">
          <mat-label>Sort date by</mat-label>
          <mat-button-toggle-group [(ngModel)]="filterSort" aria-label="Select an option"
            [matTooltip]="filterSort" [matTooltipShowDelay]="500"
            hideSingleSelectionIndicator>
            @for (option of dateSortOptionsArray; track $index) {
              <mat-button-toggle [value]="option">
                {{ option }}
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <mat-label>Limit number of {{ filterLabel }}s to</mat-label>
        <input type="number" [(ngModel)]="filterCount" placeholder="Count"
          appNumberInputLimits [min]="1" [max]="500"
          appWholeNumberOnly/>
        </td>
        <td>
          <mat-label matTooltip="If checked, the results from this filter will automatically be included in the prompt"
            matTooltipShowDelay="500">
            Automatically include filtered {{ filterLabel }}s?
          </mat-label>
          <mat-checkbox [(ngModel)]="filterAutoInclude"
            matTooltip="If checked, the results from this filter will automatically be included in the prompt"
          matTooltipShowDelay="500"></mat-checkbox>
        </td>
      </tr>
    </table>
  </mat-expansion-panel>
